import { therapyPlanningAction } from 'src/redux/actions/constant';

const {
    DELETE_MDS_ASSESSMENT_BY_DATE_REQUEST,
    DELETE_MDS_ASSESSMENT_BY_DATE_SUCCESS,
    DELETE_MDS_ASSESSMENT_BY_DATE_FAILURE,
    DELETE_MDS_ASSESSMENT_BY_DATE_RESET,
    DELETE_MDS_ASSESSMENT_BY_DATE_LOADING,
} = therapyPlanningAction;

const intitialstate: object = {
  response: null,
  loading: false,
  isMdsAssessmentDeleted: false,
};

export const deleteMdsAssessmentByDateReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case DELETE_MDS_ASSESSMENT_BY_DATE_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isMdsAssessmentDeleted: true,
      };
    }

    case DELETE_MDS_ASSESSMENT_BY_DATE_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isMdsAssessmentDeleted: false,
      };
    case DELETE_MDS_ASSESSMENT_BY_DATE_LOADING:
      return {
        ...state,
        loading: true,
      };

    case DELETE_MDS_ASSESSMENT_BY_DATE_RESET:
      return intitialstate;

    default:
      return state;
  }
};
